/**
 * A release posted more than this many years ago is "old": its articles are often missing, and
 * its availability check can take very long, so picking it asks for confirmation first.
 */
export const OLD_RELEASE_YEARS = 5;

function parse(postedAt: string | null): Date | null {
  if (postedAt === null) return null;
  const posted = new Date(postedAt);
  return Number.isNaN(posted.getTime()) ? null : posted;
}

/** True when the release was posted more than `OLD_RELEASE_YEARS` years before `now`. */
export function isOldRelease(postedAt: string | null, now: Date = new Date()): boolean {
  const posted = parse(postedAt);
  if (posted === null) return false;
  const threshold = new Date(now);
  threshold.setFullYear(threshold.getFullYear() - OLD_RELEASE_YEARS);
  return posted.getTime() < threshold.getTime();
}

/** Full years between the post date and `now`; 0 for an unknown or unreadable date. */
export function releaseAgeYears(postedAt: string | null, now: Date = new Date()): number {
  const posted = parse(postedAt);
  if (posted === null) return 0;
  let years = now.getFullYear() - posted.getFullYear();
  const anniversary = new Date(posted);
  anniversary.setFullYear(now.getFullYear());
  if (anniversary.getTime() > now.getTime()) years -= 1;
  return Math.max(0, years);
}
